import React from 'react';

import { makeStyles } from 'tss-react/mui';
import { Box, Typography } from '@mui/material';
import { Icon } from 'semantic-ui-react';

import OhsLoginFooter from 'login/OhsLoginFooter';

import scLogo from '../../../angular-modules/build/img/sc-logo.png';

const useStyles = makeStyles()((theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'center',
    minHeight: '100vh',
  },
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    marginTop: theme.spacing(2),
  },
  logo: {
    width: '50%',
  },
  errorText: {
    margin: '10px 10px 0px 10px',
    color: theme.palette.error.main,
    textAlign: 'center',
  },
  footer: {
    marginBottom: theme.spacing(2),
  },
}));

export default function OhsQrCodeInvalidOperationHome() {
  const { classes } = useStyles();

  return (
    <Box className={classes.container}>
      <Box className={classes.root}>
        <Box maxWidth="xs" display="flex" justifyContent="center" marginBottom="15px">
          <img className={classes.logo} src={scLogo} alt="Safety Champion" />
        </Box>

        <Icon name="close" color="red" size="massive" />

        <Typography variant="h4" component="div" className={classes.errorText}>
          QR Code Not Found
        </Typography>
        <Typography variant="h5" component="div" className={classes.errorText}>
          The QR Code cannot be found or is not currently valid.
        </Typography>
      </Box>

      <Box className={classes.footer}>
        <OhsLoginFooter />
      </Box>
    </Box>
  );
}
